import { FC, useEffect } from "react";
import { Flex, Text } from "@chakra-ui/react";
import { AnimationControls, motion, useAnimation } from "framer-motion";
import { PageState } from "../config/pageStates";
import { PlanPillar } from "./PlanPillar";

const MotionFlex = motion(Flex);

interface Props {
  state: PageState;
  controls: AnimationControls;
}

export const YourConceivePlan: FC<Props> = ({ state }) => {
  const { plan, highlight, transitionDuration, transitionStyle } = state;
  const controls = useAnimation();

  useEffect(() => {
    controls.start({
      boxShadow: highlight ? "0px 0px 25px 0px #F7DA9C" : "none",
      transition: {
        duration: transitionDuration,
        ...transitionStyle,
      },
    });
  }, [highlight, controls, transitionDuration, transitionStyle]);

  return (
    <MotionFlex
      animate={controls}
      align="center"
      border="1px solid"
      borderColor="th.cream3"
      borderRadius="2xl"
      direction="column"
      justify="flex-start"
      minH="21rem"
      maxW="34.5rem"
      overflow="hidden"
      w="full"
    >
      <Flex align="center" bg="th.cream2" h={7} w="full">
        <Text ml={6} textTransform="uppercase" variant="th-t2">
          Your Conceive plan
        </Text>
      </Flex>
      <Flex
        align="center"
        direction="column"
        gap={14}
        h="full"
        justify="flex-start"
        py="3.75rem"
        w="full"
      >
        {plan &&
          plan?.map((planItem, idx) => (
            <PlanPillar
              key={idx}
              content={planItem.text}
              highlightColor={planItem.highlightColor}
            />
          ))}
      </Flex>
    </MotionFlex>
  );
};
